import script from "./AwaitVoucherPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AwaitVoucherPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AwaitVoucherPanel.vue?vue&type=style&index=0&id=607ee208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607ee208"]])

export default __exports__